module.exports = __webpack_public_path__ + "static/media/Snare808_2.13b891cb.wav";